export default {
      id: "ic_down_arrow-usage",
      viewBox: "0 0 18 11",
      url: "/" + "images/icons.3.109.2.svg#ic_down_arrow-usage",
      toString: function () {
        return this.url;
      }
    }